// @ts-nocheck
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetShipmentsApiParameter>;

export const DispatchUpdateDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ShipmentHistory/UpdateDraftParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateDraftParameter];

const updateDraftParameter = createHandlerChainRunner(chain, "UpdateDraftParameter");
export default updateDraftParameter;
